// extracted by mini-css-extract-plugin
module.exports = {"rating":"_2H5xG","starRating":"_39FPG","starRatingCount":"_3qRxZ"};